import type { Permission } from "@backchannel/tax-contracts";

export type ReviewQueueCounts = {
  evidenceWaiting: number;
  proposalsWaiting: number;
};

export type ReviewLanding = {
  to: "/proposals" | "/evidence";
  search: { status?: string };
};

const PROPOSALS_FALLBACK: ReviewLanding = { to: "/proposals", search: {} };

/**
 * Revisões opens the queue that currently has items waiting for review.
 * Propostas is the fallback when nothing is waiting, or when both queues
 * are equally busy. Fontes health and the discovery desk are not review queues.
 */
export function reviewLandingForOverview(
  overview:
    | {
        evidenceQueue: { total: number };
        proposals: { inReview: number };
      }
    | null
    | undefined,
  can: (permission: Permission) => boolean,
): ReviewLanding {
  const canRules = can("READ:TAX_RULE:ALL");
  const canNews = can("READ:TAX_NEWS:ALL");
  const proposalsWaiting = canRules ? (overview?.proposals.inReview ?? 0) : 0;
  const evidenceWaiting = canNews ? (overview?.evidenceQueue.total ?? 0) : 0;

  if (evidenceWaiting === 0 && proposalsWaiting === 0) {
    if (canRules) return PROPOSALS_FALLBACK;
    if (canNews) return { to: "/evidence", search: {} };
    return PROPOSALS_FALLBACK;
  }

  if (evidenceWaiting > proposalsWaiting) {
    return { to: "/evidence", search: { status: "NEW,IN_REVIEW" } };
  }

  return { to: "/proposals", search: { status: "PENDING_REVIEW" } };
}
